<template>
	<div :class="`container mx-auto h-[${height}px] overflow-hidden relative`">
		<ul
			class="will-change-transform"
			:class="[
				`h-[${height}px]`,
				shouldTransition &&
					'transition-transform duration-300 ease-[cubic-bezier(0,0.2,1,0.8)]'
			]"
			:style="{ transform: transformStyle }"
		>
			<li
				v-for="(item, idx) in sliderItems"
				:key="idx"
				:class="`h-[${height}px] flex items-center justify-center text-[15px]`"
			>
				<img
					v-if="getImage(item)"
					:src="getImage(item)"
					alt=""
					class="inline"
				/>
				<span class="ml-2">{{ item.text }}</span>
			</li>
		</ul>
	</div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import type { ImageElement } from "~/types/storyblok/storyblok";

interface TopBarItem {
	id: string;
	img?: string;
	image?: ImageElement[];
	text?: string;
}

const props = withDefaults(
	defineProps<{
		items: TopBarItem[];
		height?: string | number;
	}>(),
	{
		height: 42
	}
);

const sliderItems: ComputedRef<TopBarItem[]> = computed(() =>
	props.items.length > 0
		? [...props.items, { ...props.items[0], id: "-loop" }]
		: []
);

const { transformStyle, startAutoScroll, shouldTransition } = useVerticalSlider(
	sliderItems.value
);

const getImage = (item: TopBarItem) =>
	item.img || item.image?.[0]?.image?.filename;

onMounted(() => {
	startAutoScroll();
});
</script>
